import React from 'react'
import clsx from 'clsx'
import TermsOfUseLinks from 'components/shared/TermsOfUseLinks';
import SocialLinks from 'modules/auth/components/SocialLinks';
import { StringConstant } from 'utils/Constants';
import SignInLink from './SignInLink';
import styles from './SignUp.module.scss';

type HomeViewProps = {
  handleNext: () => void,
  goToSignIn: () => void,
  className?: string,
}

function HomeView({
  handleNext,
  goToSignIn,
  className,
}: HomeViewProps) {
  React.useEffect(()=> {
    handleNext()
  },[])
  return (
    <div className={className}>
      <div className={clsx(styles.subheader, styles.subheaderGrey)}>
        {StringConstant.INTRODUCTION}
      </div>

      <div className={styles.panelFooter}>
        <SignInLink onClick={goToSignIn} />
        <TermsOfUseLinks />
      </div>
    </div>
  )
}

export default HomeView
